export const floatBtn = {
  floatBtnWithdrawl: "Withdrawal",
  floatBtnDeposit: "Deposit",
};
